// 배럴(@/hooks)에는 'use client' 누락 모듈이 섞여 있어, 서버 컴포넌트(page.tsx)가
// 이 훅을 거쳐 배럴 전체를 끌어오면 RSC 경계 에러가 난다. 개별 모듈로 직접 import한다.
import { isMacarongApp } from '@/shared/lib'
import useIsMounted from '@/shared/model/useIsMounted'

/**
 * 인앱 레이아웃 강제 미리보기용 쿼리 파라미터 (`?webview=1`).
 * 일반 브라우저에서 인앱 웹뷰 화면을 따로 확인하기 위한 QA/디자인 검증 수단.
 */
const WEBVIEW_PREVIEW_PARAM = 'webview'

const hasWebviewPreviewParam = (): boolean => {
  if (typeof window === 'undefined') return false

  return (
    new URLSearchParams(window.location.search).get(WEBVIEW_PREVIEW_PARAM) ===
    '1'
  )
}

/**
 * 마이클 인앱 웹뷰(WebView)에서 실행 중인지 여부.
 *
 * SSR·최초 렌더에서는 항상 false(웹으로 간주)이며, 마운트 후에 판별한다.
 * → 크롤러·웹 방문자에게는 전체 UI가 그대로 렌더되어 SEO에 영향이 없다.
 *
 * 판별 기준:
 * 1. User-Agent에 'Macarong' 포함 (실제 인앱 웹뷰)
 * 2. URL에 `?webview=1` (일반 브라우저에서 인앱 화면 미리보기 — QA/디자인 확인용)
 */
export const useIsInApp = (): boolean => {
  const isMounted = useIsMounted()

  if (!isMounted) return false

  return isMacarongApp() || hasWebviewPreviewParam()
}
